import { LookupItem } from '@app/core/models/app/lookup-item.model';

export class EntityLookup {
  lookupDbTableName: string;
  lookupName: string;
  lookupType: string;
  lookupValues: LookupItem[];
}
